module.exports = __webpack_public_path__ + "img/timeStep.1adcf43e.svg";